
export { useScribeMessage, useScribeMessageFilter } from './hooks';
export { ScribeError, ScribeErrorCode, createScribeError } from './errors';

// Web/Frontend API exports
export {
  sendMessageToExtension,
  useExtensionMessage,
  canCommunicateWithExtension,
  configureExtension,
  type ExtensionMessageResponse,
} from './web';

// Core API - Immediate type inference
export { MessageHandlerBuilder, createMessageHandlers } from './builder';

// Legacy API exports
export {
  onScribeMessageBackground,
  onScribeMessageExternalBackground,
} from './legacy';

export type {
  ChromeMessageListener,
  GenericMessageHandler,
  SendError,
  SendResponse,
} from './types';
